// DS: i4.5
import React from 'react';
import IconWrap from '../../IconWrap';
const FollowingWatch = (props)=>{
    return /*#__PURE__*/ React.createElement(IconWrap, props, /*#__PURE__*/ React.createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M8 3c2.295 0 4.405 1.37 6.38 3.937l.186.244.293.394a.712.712 0 01.05.772l-.05.078-.293.394C12.536 11.543 10.366 13 8 13c-2.295 0-4.405-1.37-6.38-3.937l-.186-.244-.293-.394a.712.712 0 01-.05-.772l.05-.078.293-.394C3.464 4.457 5.635 3 8 3zm0 1.429A3.58 3.58 0 004.412 8 3.58 3.58 0 008 11.571 3.58 3.58 0 0011.588 8 3.58 3.58 0 008 4.429zm.253 1.676l1.642 1.642a.358.358 0 010 .506L8.253 9.895a.358.358 0 01-.506 0L6.105 8.253a.358.358 0 010-.506l1.642-1.642a.358.358 0 01.506 0z",
        fillRule: "evenodd"
    })));
};
FollowingWatch.displayName = 'FollowingWatch';
export default FollowingWatch;
